import React, {useCallback, useState, useEffect, useRef} from 'react';
import {getMwChart} from "../../api";
import {Preloader} from "../../../../components/Preloader";
import {SequenceLabelItem} from "./SequenceLabelItem";
import { getMediaUrl } from '../../../../utils/utils';
import PremiumIcon from '../../../../icons/premium.svg';
import StandardIcon from '../../../../icons/standart.svg';

const available_charts = {
  // temporary hide CASH HU from MW charts
  // preflop_hu_cash: {
  //   label: 'Cash HU',
  //   stack: [100, 200],
  //   positions: ['SB', 'BB'],
  // },
  preflop_6max_cash: {
    label: 'Cash 6max',
    stack: [100],
    positions: ['UTG', 'HJ', 'CO', 'BTN', 'SB', 'BB'],
  },
  preflop_8max_cash: {
    label: 'Cash 8max',
    stack: [100, 200],
    positions: ['UTG', 'UTG+1', 'LJ', 'HJ', 'CO', 'BTN', 'SB', 'BB'],
  }
};

export const Sequence = ({chartData, setChartData, selectedFilters, showAccessPopup, userAccess, seqData, setSeqData}) => {
  const [sequence, setSequence] = useState([]);
  const [chartType, setChartType] = useState(null);
  const [stackSize, setStackSize] = useState(null);
  const [reqAct, setReqAct] = useState([]);
  const [reqActAmount, setReqActAmount] = useState([]);
  const [loading, setLoading] = useState(false)
  const containerRef = useRef(null);
  const [chartNotFound, setChartNotFound] = useState(false);
  const [reqNodeId, setReqNodeId] = useState(0);
  const [actions, setActions] = useState([])

  const clickCardAction = (value, node) => {
    if (!value.next_node) {
      setChartNotFound(true)
    }

    // remove from sequence all nodes after clicked node
    const index = sequence.findIndex(item => item.id === node.id);
    if (index !== -1) {
      setSequence(prevSequence => prevSequence.slice(0, index + 1));
    }

    setReqNodeId(value.next_node)

    if (reqAct.length < index) {
      for (let i = reqAct.length; i < index; i++) {
        setReqAct(prevReqAct => [
          ...prevReqAct,
          'F'
        ]);
        setReqActAmount(prevReqActAmount => [
          ...prevReqActAmount,
          'F'
        ]);
      }
    }

    // remove from reqAct all actions after clicked node
    setReqAct(prevReqAct => prevReqAct.slice(0, index));
    setReqActAmount(prevReqActAmount => prevReqActAmount.slice(0, index));
    setActions(prevActions => prevActions.slice(0, index));

    setReqAct(prevReqAct => [
      ...prevReqAct,
      value.type
    ]);

    const raa = (value.type === 'RAI') ? 'R' : value.type;
    setReqActAmount(prevReqActAmount => [
      ...prevReqActAmount,
      (value.type !== 'F') ? raa+value.amount : value.type
    ]);

    setActions(prevActions => [
      ...prevActions,
      {
        [node.position]: (value.type !== 'F') ? raa+value.amount : value.type
      }
    ]);


  };


  const addToSequence = (node) => {
    if (!node.id) {
      setSequence(prevSequence => [
        ...prevSequence,
        {
          id: node.id,
          position: node.position,
          available_actions: node.available_actions,
        }
      ]);
      return;
    }

    const existingIndex = sequence.findIndex(item => item.id === node.id);

    if (existingIndex !== -1) {
      // If the object with the same id exists, update it
      setSequence(prevSequence => {
        const updatedSequence = [...prevSequence];
        updatedSequence[existingIndex] = {
          id: node.id,
          position: node.position,
          available_actions: node.available_actions,
        };
        return updatedSequence;
      });
    } else {
      // If the object doesn't exist, add it to the end
      setSequence(prevSequence => [
        ...prevSequence,
        {
          id: node.id,
          position: node.position,
          available_actions: node.available_actions,
        }
      ]);
    }
  };

  useEffect(async () => {
    await updateChart()
  }, [reqAct, chartType, stackSize]);

  useEffect(() => {
    // reset sequence if chart type or stack size changed
    setSequence([])
    setReqActAmount([])
    setReqNodeId(0)
    setActions([])
  }, [chartType, stackSize]);

  useEffect(() => {
    if(selectedFilters.chartType){
      switch (selectedFilters.chartType) {
        case 'CASH HU':
          setChartType('preflop_hu_cash')
          break;
        case 'CASH 6max':
          setChartType('preflop_6max_cash')
          break;
        case 'CASH 8max':
          setChartType('preflop_8max_cash')
          break;
      }
    }
  }, []);


  const updateChart = () => {
    if (!chartType || !stackSize) return;
    setLoading(true)
    setTimeout(() => {
      if (containerRef.current) {
        containerRef.current.scrollLeft = containerRef.current.scrollWidth;
      }
    }, 500);

    if (chartNotFound) {
      addToSequence({
        id: null,
        position: null,
        available_actions: null,
      });
      setChartNotFound(false)
      setLoading(false)
      return;
    }
    const chart = getMwChart({
      type: chartType,
      stack: stackSize,
      preflop_actions: reqAct.join('-'),
      rnid: reqNodeId,
    });
    chart.then((chart) => {
      addToSequence({
        id: chart.node ?? null,
        position: chart.node_data.position,
        available_actions: chart.node_data.available_actions,
      });
      setSeqData({
        ...seqData,
        reqAct,
        reqActAmount,
        actions,
        position: chart.node_data.position,
      });
      if (chart.node) {
        setChartData({chartHTML: chart.chart_html, chartActions: chart.chart_actions});
      }
      setLoading(false)


      chart.seats_nodes.forEach((position) => {
        addToSequence({
          id: position.node ?? null,
          position: position.position,
          available_actions: position.available_actions,
        });
      });

    });

  };

  const handleClickCard = (node) => {
    setReqNodeId(node.id)

    // return; if node.id is last in sequence
    if (sequence.length && sequence[sequence.length - 1].id === node.id) return;

    // remove from sequence all nodes after clicked node
    const index = sequence.findIndex(item => item.id === node.id);
    if (index !== -1) {
      setSequence(prevSequence => prevSequence.slice(0, index + 1));
    }
    // remove from reqAct all actions after clicked node
    setReqAct(prevReqAct => prevReqAct.slice(0, index));
    setReqActAmount(prevReqActAmount => prevReqActAmount.slice(0, index));
    setActions(prevActions => prevActions.slice(0, index));

  };

  const renderSequenceItems = useCallback(() => {
    return Object.entries(sequence).map(([key, value]) => {
      return (
        <SequenceLabelItem
          key={key}
          label={value}
          clickCardAction={clickCardAction}
          activeIndex={key}
          sequence={sequence}
          reqAct={reqAct}
          handleClickCard={handleClickCard}
        />
      );
    });
  }, [sequence, chartType, stackSize, chartData]);

  const updateChartType = (type) => {
    setChartType(type)
    setReqAct([])
    setSequence([])
    setActions([])
    setReqNodeId(0)

    if (!available_charts[type].stack.includes(stackSize)) {
      setStackSize(null)
    }

    setSeqData({
      ...seqData,
      reqAct,
      reqActAmount,
      actions,
      chartType: type,
    });

  };


  const updateChartSize = (val) => {
    if(userAccess !== 'pcp' && userAccess !== 'pc'){
      showAccessPopup(true)
      return
    }

    setSeqData({
      ...seqData,
      reqAct,
      reqActAmount,
      actions,
      stackSize: val,
    });

    setStackSize(val)
    setReqAct([])
    setSequence([])
    setReqNodeId(0)
    setActions([])
  };

  const needAccess = (blind) => {
    return userAccess !== 'pcp' && userAccess !== 'pc';
  }

  return <div className="PreflopCharts__chart-sequence" ref={containerRef}>
    <div className={"PreflopCharts__chart-sequence-card settings"}>
      <div className={"PreflopCharts__chart-sequence-card-wrapper"}>
        <div className={"PreflopCharts__chart-sequence-card-wrapper-header"}>
          <div>Chart Type</div>
        </div>
        <div className={"PreflopCharts__chart-sequence-card-wrapper-actions"}>
          {
            Object.entries(available_charts).map(([key, value]) => {
              return (
                <div
                  key={key}
                  onClick={() => updateChartType(key)}
                  className={(chartType === key ? ' active' : '')}
                >{value.label}
                </div>
              );
            })
          }
        </div>
      </div>
    </div>
    <div className={"PreflopCharts__chart-sequence-card settings"}>
      <div className={"PreflopCharts__chart-sequence-card-wrapper"}>
        <div className={"PreflopCharts__chart-sequence-card-wrapper-header"}>
          <div>Stack Size</div>
        </div>
        <div className="PreflopCharts__chart-sequence-card-wrapper-actions">
          {Object.values(available_charts)
            .map((value) => value.stack)
            .flat()
            .filter((value, index, self) => self.indexOf(value) === index)
            .filter((value) => {
              if (chartType) {
                const selectedChart = available_charts[chartType];
                return selectedChart && selectedChart.stack.includes(value);
              }
              return true; // If no chartType is selected, show all stack values
            })
            .map((value) => {
              const needsAccess = needAccess(value)
              return (
              <div
                key={value}
                onClick={() => updateChartSize(value)}
                className={stackSize === value ? 'active' : ''}
              >
                { needsAccess &&
                  <>
                    <img
                      alt=""
                      className="PreflopCharts__access-chip_image"
                      style={{ marginRight: '-4px' }}
                      src={getMediaUrl(StandardIcon)}
                    />
                    <img
                      alt=""
                      className="PreflopCharts__access-chip_image"
                      style={{ marginRight: '3px' }}
                      src={getMediaUrl(PremiumIcon)}
                    />
                  </>
                }
                {value}
              </div>
            )
            })}
        </div>


      </div>
    </div>

    {chartType && stackSize && renderSequenceItems()}

    {loading &&
      <div className={"PreflopCharts__chart-sequence-card loading"}>
        <div className={"PreflopCharts__chart-sequence-card-wrapper"}>
          <div className={"PreflopCharts__chart-sequence-card-wrapper-notfound"}>
            <Preloader isSmall/>
          </div>
        </div>
      </div>
    }


  </div>
    ;
};
